module.exports = __webpack_public_path__ + "img/1.8aeb769f.png";